/*
 * Copyright (c) 2024 Paul Ostrowski. All rights reserved.
 *
 * This software is the proprietary information of Paul Ostrowski.
 * Unauthorized copying, modification, or distribution of this code, via any medium, is strictly prohibited.
 * This code is proprietary and confidential.
 *
 * For licensing inquiries, contact Paul Ostrowski at postrowski@gmail.com.
*/

import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import MonsterForge from './MonsterForge';
import ModerationPage from 'components/sharing/ModerationPage';
import PrivacyNotice from './auth/PrivacyNotice';
import TermsAndConditions from './auth/TermsAndConditions';
import Account from './auth/Account';
import SubscriptionSuccess from './auth/SubscriptionSuccess';
import { User } from 'firebase/auth';

const App: React.FC = () => {
  return (
    <Router>
      <Routes>
        <Route path="/monsterforge" element={<MonsterForge/>} />
        {/* Public, shareable view of a single monster, owned by :username and named :monstername.
            Renders the normal editor shell (signed-out visitors can view, then sign in / sign up);
            the monster loads read-only because it isn't owned by the current visitor. */}
        <Route path="/monsterforge/mon/:username/:monstername" element={<MonsterForge/>} />
        {/* A built-in catalog monster, addressed by its unique data-model key (used by moderation
            links for reports on catalog monsters, which have no owner). Loaded client-side. */}
        <Route path="/monsterforge/cat/:monsterKey" element={<MonsterForge/>} />
        <Route path="/monsterforge/account" element={<Account onClose={() => {window.location.href = '/monsterforge'}} onUserChanged={(newUser: User | null) => {}}/>} />
        {/* Approver-only moderation page (access enforced server-side via canApprove). */}
        <Route path="/monsterforge/moderation" element={<ModerationPage/>} />
        <Route path="/monsterforge/subscription-success" element={<SubscriptionSuccess onClose={() => {window.location.href = '/monsterforge'}}/>} />
        <Route path="/monsterforge/dataPrivacy" element={<PrivacyNotice onClose={() => {window.location.href = '/monsterforge'}} />} />
        <Route path="/monsterforge/terms" element={<TermsAndConditions onClose={() => {window.location.href = '/monsterforge'}} />} />
      </Routes>
    </Router>
  );
};

export default App;